module.exports = __webpack_public_path__ + "static/tooltip1-a8174080e74f727b0ab6060b2d422a48.png";